import { render, staticRenderFns } from "./SavedConfigurations.vue?vue&type=template&id=ca391348&"
import script from "./SavedConfigurations.vue?vue&type=script&lang=js&"
export * from "./SavedConfigurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca391348')) {
      api.createRecord('ca391348', component.options)
    } else {
      api.reload('ca391348', component.options)
    }
    module.hot.accept("./SavedConfigurations.vue?vue&type=template&id=ca391348&", function () {
      api.rerender('ca391348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/configurationManager/SavedConfigurations.vue"
export default component.exports